import React from 'react';
import { Route } from 'react-router-dom';
import RecentPlacements from '../News Pages/ListOfPlacements';
import PlacementNewsPage from '../News Pages/PlacementNewsPage';
import MonthlyNewsPage from '../News Pages/MonthlyNews';
import SuccessStoriesList from '../Component/Our Success Stories/SuccessStoriesList';
import EmpoweringLead from '../Component/Our Success Stories/EmpoweringLead';
import RegionalInternship from '../Component/Our Success Stories/RegionalInternship';

export const newsAndInsightsRoutes = [
  <Route key="news-and-insights" path="/news-and-insights/recent-placements" element={<RecentPlacements />} />,
  <Route key="placement-detail" path="/news-and-insights/recent-placements/:id" element={<PlacementNewsPage />} />,
  <Route key="monthly-newsletter" path="/news-and-insights/monthly-newsletter" element={<MonthlyNewsPage />} />,
  <Route key="success-stories" path="/news-and-insights/our-success-stories" element={<SuccessStoriesList />} />,
  <Route key="empowering-lead" path="/news-and-insights/our-success-stories/empowering-lead" element={<EmpoweringLead />} />,
  <Route key="regional-internship" path="/news-and-insights/our-success-stories/regional-internship" element={<RegionalInternship />} />,
]